import { Center, Spinner } from '@chakra-ui/react';

import { useLoadingStore } from '@/stores/loading-store';

interface LoadingOverlayProps {
  children: React.ReactNode;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = (props) => {
  console.info('loading-overlay.tsx_1');

  const { children } = props;
  const isLoading = useLoadingStore((state) => state.isLoading);

  return (
    <>
      {isLoading && (
        <Center
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0, 0, 0, 0.5)"
          zIndex="2000"
        >
          <Spinner size="xl" color="white" />
        </Center>
      )}
      {children}
    </>
  );
};
